import * as Packery from "packery";
import {throttle} from "throttle-debounce";

let allGrids = [];

export function init() {
	let html = document.querySelector('html');
	if (!html.classList.contains('ie11')) { return; }

	let imageGrids = document.querySelectorAll('.image-grid');

	for (let i = 0; i < imageGrids.length; i++) {
		let el = imageGrids[i];

		let packery = new Packery(el, {
			itemSelector: '.image-grid__item'
		});

		allGrids.push(packery);
	}

	(window as any).addEventListener('resize', throttle(150, false, (event) => {
		for (let i = 0; i < allGrids.length; i++) {
			let grid:any = allGrids[i];
			grid.layout();
		}
	}));
}
